export default function initFileUploader(target) {
    "use strict";

    // target = UploadDocumentForm
    const form =  document.getElementById(target);

    if( form === null ) {
        return;
    }

    

    const file_uploaders = form.querySelectorAll('.file-upload');
    file_uploaders.forEach(function(file_uploader) {
        setupFileUploading(file_uploader, form)
    });
}

const setupFileUploading = (file_uploader, form) => {
    var input = file_uploader.querySelector('input[type="file"]');
    var files = [];
    let dataTransferList = new DataTransfer();

    const label = file_uploader.querySelector(".file-upload__label");
    const file_list = file_uploader.querySelector(".file-upload__file-list");

    const addFileName = (file) => {
        let current_count = file_list.querySelectorAll("li").length || 0;

        let a = document.createElement('a');
        let textNode = document.createTextNode('x');

        a.href = "#";
        // a.appendChild( textNode );
        a.innerHTML = '<i class="icon-cross fa-2x"></i>';
        let textNode2 = document.createTextNode(file.name);
        a.appendChild( textNode2 );

            a.addEventListener('click', function(e) {
                e.preventDefault();
                // remove from ui
                let parent = e.target.parentNode;
      
                parent.remove();
                
                // remove from the input field type file
                // let index = function() {
                //     let index = 0;
                //     Array.prototype.forEach.call(input.files, function (f, i) {
                //         if( f.name == file.name ) {
                //             index = i;
                //             break;
                //         }
                //     });
                //     return index;
                // }

                console.log('files.length (1): ' + files.length);
                console.log('files: ' + files);
                for( var i = 0; i < files.length; i++) {
                    if(files[i].name === file.name) {
                        files.splice( i, 1 );
                        break;
                    }
                }

                console.log('files.length (2): ' + files.length);

                // if all files removed from the list, set input type file to be empty
                if( ! files.length ) {
                    input.value = null;
                        console.log('files.length is null 1');
                } else {

                    if (files.length == 0){
                        console.log('files.length is zero');
                    }
                    
                    dataTransferList = new DataTransfer();
                    for( var i = 0; i < files.length; i++) {
                        dataTransferList.items.add(files[i]);
                    }
                    input.files = dataTransferList.files;
                }

                // update count label
                label.dataset.count = files.length;
                label.textContent = ( input.getAttribute("data-multiple-caption") || "" ).replace("{count}", files.length);

                if( ! files.length ) {
                    label.textContent = "";
                }

                console.log('files.length (3): ' + files.length);
                console.log('input.files: ' + input.files.length);

            });

            
        let div = document.createElement('li');
            // textNode = document.createTextNode(file.name);
            div.appendChild( a );
            // div.appendChild( textNode );
            file_list.appendChild( div );
    };

    // applying the effect for every form  
    const errorMsg = file_uploader.querySelector(".file-upload__error span");
    const restart = file_uploader.querySelectorAll(".file-upload__restart");
    let droppedFiles = false;
    const showFiles = (new_files) => {
        label.textContent = ( input.getAttribute("data-multiple-caption") || "" ).replace("{count}", files.length);

        Array.prototype.forEach.call(new_files, function (file) {
            addFileName( file );
        });

        // label.textContent +=
        //     files.length > 1
        //         ? (
        //               input.getAttribute("data-multiple-caption") || ""
        //           ).replace("{count}", files.length)
        //         : files[0].name + ' \r\n';
    },
    triggerFormSubmit = function () {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("submit", true, false);
        form.dispatchEvent(event);
    };

    // letting the server side to know we are going to make an Ajax request
    var ajaxFlag = document.createElement("input");
    ajaxFlag.setAttribute("type", "hidden");
    ajaxFlag.setAttribute("name", "ajax");
    ajaxFlag.setAttribute("value", 1);
    form.appendChild(ajaxFlag);

    // automatically submit the form on file select
    input.addEventListener("change", function (e) {
        files = files.concat(Array.prototype.slice.call(e.target.files));
        // files = Array.prototype.slice.call(e.target.files);

        showFiles(e.target.files);
        
        dataTransferList = new DataTransfer();
        for( var i = 0; i < files.length; i++) {
            dataTransferList.items.add(files[i]);
        }
        input.files = dataTransferList.files;
        // console.log(           // triggerFormSubmit();
    });

    // drag&drop files if the feature is available
    if (isAdvancedUpload) {
        form.classList.add("has-advanced-upload"); // letting the CSS part to know drag&drop is supported by the browser

        [
            "drag",
            "dragstart",
            "dragend",
            "dragover",
            "dragenter",
            "dragleave",
            "drop",
        ].forEach(function (event) {
            form.addEventListener(event, function (e) {
                // preventing the unwanted behaviours
                e.preventDefault();
                e.stopPropagation();
            });
        });
        ["dragover", "dragenter"].forEach(function (event) {
            form.addEventListener(event, function () {
                form.classList.add("is-dragover");
            });
        });
        ["dragleave", "dragend", "drop"].forEach(function (event) {
            form.addEventListener(event, function () {
                form.classList.remove("is-dragover");
            });
        });
        form.addEventListener("drop", function (e) {
            droppedFiles = e.dataTransfer.files; // the files that were dropped

            // files for state management
            files = files.concat(Array.prototype.slice.call(e.dataTransfer.files));
            // files = Array.prototype.slice.call(e.dataTransfer.files)
            showFiles(e.dataTransfer.files);

            dataTransferList = new DataTransfer();
            for( var i = 0; i < files.length; i++) {
                dataTransferList.items.add(files[i]);
            }
            input.files = dataTransferList.files;

            // triggerFormSubmit();
        });
    }

    // if the form was submitted
    form.addEventListener("submitsss", function (e) {
        // preventing the duplicate submissions if the current one is in progress
        if (form.classList.contains("is-uploading")) return false;

        if (form.classList.contains("is-success")) {
            form.classList.remove("is-success");
        }

        if( ! input.files.length && ! droppedFiles ) {
            return;
        }

        form.classList.add("is-uploading");
        form.classList.remove("is-error");
        
        if (isAdvancedUpload) {
            // ajax file upload for modern browsers
            e.preventDefault();

            
            return;
            let myFileList = list.files

            
            console.log( 'input files: ', input.files );
            console.log( 'var files', files );

            // gathering the form data
            var ajaxData = new FormData(form);
            if (droppedFiles) {
                Array.prototype.forEach.call(droppedFiles, function (file) {
                    ajaxData.append(input.getAttribute("name"), file);
                });
            }
            
            // ajax request
            var ajax = new XMLHttpRequest();
            ajax.open(
                form.getAttribute("method"),
                form.getAttribute("action"),
                true
            );

            ajax.onload = function () {
                form.classList.remove("is-uploading");
                if (ajax.status >= 200 && ajax.status < 400) {
                    form.classList.add(
                       "is-success"
                    );
                    input.value = null;
                    droppedFiles = null;
                } else alert("Error. Please, contact the webmaster!");
            };

            ajax.onerror = function () {
                form.classList.remove("is-uploading");
                alert("Error. Please, try again!");
            };

            ajax.send(ajaxData);
        } // fallback Ajax solution upload for older browsers
        else {
            var iframeName = "uploadiframe" + new Date().getTime(),
                iframe = document.createElement("iframe");

            $iframe = $(
                '<iframe name="' +
                    iframeName +
                    '" style="display: none;"></iframe>'
            );

            iframe.setAttribute("name", iframeName);
            iframe.style.display = "none";

            document.body.appendChild(iframe);
            form.setAttribute("target", iframeName);

            iframe.addEventListener("load", function () {
                var data = JSON.parse(
                    iframe.contentDocument.body.innerHTML
                );
                form.classList.remove("is-uploading");
                form.classList.add(
                    data.success == true ? "is-success" : "is-error"
                );
                form.removeAttribute("target");
                if (!data.success) errorMsg.textContent = data.error;
                iframe.parentNode.removeChild(iframe);
            });
        }

    });

    // restart the form if has a state of error/success
    Array.prototype.forEach.call(restart, function (entry) {
        entry.addEventListener("click", function (e) {
            e.preventDefault();
            form.classList.remove("is-error", "is-success");
            input.click();
        });
    });

    // Firefox focus bug fix for file input
    input.addEventListener("focus", function () {
        input.classList.add("has-focus");
    });
    input.addEventListener("blur", function () {
        input.classList.remove("has-focus");
    });
};

// feature detection for drag&drop upload
const isAdvancedUpload = function () {
    var div = document.createElement("div");
    return (
        ("draggable" in div ||
            ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
    );
};